import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MachineUnites } from 'src/app/model/machine/machine.model';
import { MachineService } from 'src/app/services/http/machine/machine.service';

@Component({
  selector: 'app-machine-equipment',
  templateUrl: './machine-equipment.component.html',
  styleUrls: ['./machine-equipment.component.scss']
})
export class MachineEquipmentComponent implements OnInit {

  @Input() identifiant !: any;

  public equipments!: MachineUnites;

  constructor(private service: MachineService, private router : Router) { }

  ngOnInit(): void {

    this.service.getMaterielUnite(this.identifiant)
      .subscribe((equipments) => {
        for (let i = 0; i < equipments.machine_unites.length; i++) {
          switch (equipments.machine_unites[i].classe_tag) {
            case 1:
              equipments.machine_unites[i].maticon = 'dialpad';
              break;
            case 2:
              equipments.machine_unites[i].maticon = 'speed';
              break;
            case 3:
              equipments.machine_unites[i].maticon = 'speed';
              break;
            case 4:
              equipments.machine_unites[i].maticon = 'monetization_on';
              break;
            case 5:
              equipments.machine_unites[i].maticon = 'money';
              break;
            case 6:
              equipments.machine_unites[i].maticon = 'computer';
              break;
            case 7:
              equipments.machine_unites[i].maticon = 'memory';
              break;
            case 11:
              equipments.machine_unites[i].maticon = 'memory';
              break;
            case 13:
              equipments.machine_unites[i].maticon = 'payment';
              break;
            case 15:
              equipments.machine_unites[i].maticon = 'print';
              break;
            case 20:
              equipments.machine_unites[i].maticon = 'videocam';
              break;
            default:
              equipments.machine_unites[i].maticon = 'question_mark';
              break

          }
        }
        this.equipments = equipments;
      });

  }

  /**
   * Go to materiel page
   * @param id : equipment id_mat_unite
   */

   getMatPage(id : number) {
    this.router.navigate(['materiel', id]);
  }


}
